import { Environment } from '../app/models/environment.model';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://alia-api.maverick-hunter-abzo.tech/api',
};
